
import Notification from '@/components/helper/Notification.vue'
import { JigHelpers } from '@/utils/jig-helpers'
import IconPencil from '@svg/IconPencil.svg'
import IconUserGroup from '@svg/IconUserGroup.svg'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    IconPencil,
    IconUserGroup,
    Notification,
  },
})
export default class GenerateJigPreviewSection extends Vue {
  @Prop({ type: String, required: true })
  public previewUrl!: string

  @Prop({ type: String, required: true })
  public generatedJigId!: string

  @Prop({ type: String, default: '' })
  public editUrl!: string

  @Prop({ type: String, default: '' })
  public deeplinkUrl!: string

  @Prop({ type: String, default: '' })
  public warningCopy!: string

  private previewIframeSrc: string = ''
  private previewIframeHeight: number = 440

  private get previewIframeStyle(): Partial<CSSStyleDeclaration> {
    return { height: this.previewIframeHeight + 'px' }
  }

  private mounted() {
    this.initializePreviewIframe()
  }

  private getPreviewIframeContainer(): HTMLElement | null {
    const refs = this.$refs as { previewIframeContainer?: HTMLElement | HTMLElement[] }
    const containerRef = refs.previewIframeContainer

    if (!containerRef) {
      return null
    }

    if (Array.isArray(containerRef)) {
      if (containerRef.length === 0) {
        return null
      }
      return containerRef[0]
    }

    return containerRef
  }

  private calculatePreviewIframeHeight(): number {
    const container = this.getPreviewIframeContainer()
    const width = container ? container.clientWidth : 0

    if (width <= 0) {
      return 0
    }

    const calculatedHeight = Math.round(width * 0.5625)
    return calculatedHeight < 440 ? 440 : calculatedHeight
  }

  private initializePreviewIframe() {
    this.previewIframeSrc = ''

    if (!this.previewUrl || this.previewUrl.length === 0) {
      return
    }

    const nextHeight = this.calculatePreviewIframeHeight()
    if (nextHeight <= 0) {
      return
    }

    this.previewIframeHeight = nextHeight

    const nextPreviewUrl = this.previewUrl

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        this.previewIframeSrc = nextPreviewUrl
      })
    })
  }

  private editInJigApp() {
    const target = JigHelpers.buildEditInAppUrl(this.generatedJigId) || this.editUrl || this.deeplinkUrl
    if (target) {
      window.open(target, '_blank')
    }
  }

  private shareWithTeam() {
    if (this.generatedJigId) {
      this.$router.push({ path: '/jig-detail/' + this.generatedJigId, query: { openActions: 'true' } })
    } else {
      this.$router.push('/jigs')
    }
    this.$emit('close')
  }
}
